import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import { TimerDisplay, TimerDigits, TimerSegment, TimerSeparator, GraceBadge, AuctionEndedBadge, } from '../../pages/AuctionHouse/AuctionDetail.styles';
const parseTimeRemaining = (endTime) => {
    const diff = Math.max(0, new Date(endTime).getTime() - Date.now());
    const totalSeconds = Math.floor(diff / 1000);
    return {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
};
const pad = (n) => String(n).padStart(2, '0');
const AuctionTimer = ({ endTime, status, supervisedState }) => {
    const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [isExpired, setIsExpired] = useState(false);
    const isPaused = supervisedState === 'paused';
    const updateTimer = useCallback(() => {
        if (!endTime) {
            setIsExpired(true);
            return;
        }
        const breakdown = parseTimeRemaining(endTime);
        const totalMs = new Date(endTime).getTime() - Date.now();
        setIsExpired(totalMs <= 0);
        setTime(breakdown);
    }, [endTime]);
    useEffect(() => {
        updateTimer();
        if (isPaused)
            return; // Don't tick when paused
        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [updateTimer, isPaused]);
    const isTerminal = status === 'closed' || status === 'cancelled';
    const totalSeconds = time.days * 86400 + time.hours * 3600 + time.minutes * 60 + time.seconds;
    const isUrgent = !isTerminal && !isExpired && totalSeconds < 3600; // < 1 hour
    if (isTerminal || (isExpired && status !== 'grace_period')) {
        return (_jsxs(TimerDisplay, { children: [_jsx("div", { className: "timer-label", children: "Auction Status" }), _jsx(AuctionEndedBadge, { children: "Auction Ended" })] }));
    }
    return (_jsxs(TimerDisplay, { "$urgent": isUrgent, children: [_jsx("div", { className: "timer-label", children: isPaused ? 'Timer Paused' : status === 'grace_period' ? 'Grace Period Ends In' : 'Time Remaining' }), _jsxs(TimerDigits, { "$urgent": isUrgent, children: [time.days > 0 && (_jsxs(_Fragment, { children: [_jsxs(TimerSegment, { "$urgent": isUrgent, children: [_jsx("span", { className: "digit", children: pad(time.days) }), _jsx("span", { className: "unit", children: "Days" })] }), _jsx(TimerSeparator, { "$urgent": isUrgent, children: ":" })] })), _jsxs(TimerSegment, { "$urgent": isUrgent, children: [_jsx("span", { className: "digit", children: pad(time.hours) }), _jsx("span", { className: "unit", children: "Hours" })] }), _jsx(TimerSeparator, { "$urgent": isUrgent, children: ":" }), _jsxs(TimerSegment, { "$urgent": isUrgent, children: [_jsx("span", { className: "digit", children: pad(time.minutes) }), _jsx("span", { className: "unit", children: "Min" })] }), _jsx(TimerSeparator, { "$urgent": isUrgent, children: ":" }), _jsxs(TimerSegment, { "$urgent": isUrgent, children: [_jsx("span", { className: "digit", children: pad(time.seconds) }), _jsx("span", { className: "unit", children: "Sec" })] })] }), status === 'grace_period' && (_jsx(GraceBadge, { children: "Grace Period Active" }))] }));
};
export default AuctionTimer;
